import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Helmet } from 'react-helmet';
import './Nos_Activite.css';
import { useTranslation } from 'react-i18next';

function Nos_Acitivite() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { t, i18n } = useTranslation();

    const [ref, inView] = useInView({
        triggerOnce: true,
    });

    const containerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 1 } },
    };

    return (
        <motion.div
            id="container_ACT"
            className={`container_ACT ${isMobile ? 'mobile-view' : ''}`}
            variants={containerVariants}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            ref={ref}
        >
            <div id="toggleContainer_ACT">
                <div className="secteur-title">
                    <span className="sub-title">{t('Nos Activités')}</span>
                    <h2>{t('DOMAINE D`ACTIVITES:')}</h2>
                    <p>
                        {t('La société « PROFESSIONAL INSPECTORS » se positionne en tant que référence dans le domaine du contrôle et de l`inspection, offrant une expertise sans égale dans une variété de secteurs clés. Nos compétences couvrent un large éventail de domaines, où nous nous engageons à garantir la sécurité, la conformité et l`excellence opérationnelle. En tant que leaders de confiance, nous sommes fiers de proposer des services de pointe dans les domaines suivants, parmi d`autres :')}
                    </p>
                </div>
            </div>
            <motion.main
                className="page-content"
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 2 }}
            >
                <motion.div className="card CND">
                    <div className="content">
                        <h2 className="title">{t('Contrôle Non Destructif (CND)')}</h2>
                        <motion.button
                            className="btn"
                            whileHover={{ scale: 1.1 }}
                        >
                            <a href="/controlCND">{t('Details')}</a>
                        </motion.button>
                    </div>
                </motion.div>
                <motion.div className="card RSC">
                    <div className="content">
                        <h2 className="title">{t('Réception et Suivi de Construction (RSC)')}</h2>
                        <motion.button
                            className="btn"
                            whileHover={{ scale: 1.1 }}
                        >
                            <a href="/controlRSC">{t('Details')}</a>
                        </motion.button>
                    </div>
                </motion.div>
                <motion.div className="card CRS">
                    <div className="content ">
                        <h2 className="title">{t('Contrôle Réglementaire de Sécurité (CRS)')}</h2>
                        <motion.button
                            className="btn"
                            whileHover={{ scale: 1.1 }}
                        >
                            <a href="/controlCRS">{t('Details')}</a>
                        </motion.button>
                    </div>
                </motion.div>
            </motion.main>
        </motion.div>
    );
}

export default Nos_Acitivite;
